import mutations from "./mutations.js";
import actions from "./actions.js";
import getters from "./getters.js";

export default {
  namespaced: true,
  state() {
    return {
      policies: {},
      signatures: {},
      rooms: {},
      reasons: {},
      checklists: {},
      posts: {},
      post: {},
    };
  },
  mutations,
  actions,
  getters,
};
